var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangePackageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2901 13.9502H11.2928C10.9086 13.9502 10.5972 14.2486 10.5972 14.6167V15.2862C10.5972 15.6543 10.9086 15.9527 11.2928 15.9527H18.2901C18.6743 15.9527 18.9857 15.6543 18.9857 15.2862V14.6167C18.9857 14.2486 18.6743 13.9502 18.2901 13.9502Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5094 11.9507H18.2866C18.6707 11.9507 18.9823 12.2493 18.9823 12.6172V13.2867C18.9823 13.6547 18.6707 13.9532 18.2866 13.9532H11.2894C10.9054 13.9532 10.5938 13.6547 10.5938 13.2867",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6807 9.948H18.2901C18.6741 9.948 18.9857 10.2466 18.9857 10.6145V11.284C18.9857 11.652 18.6741 11.9505 18.2901 11.9505H14.2988",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7119 7.94849H17.1441C17.5281 7.94849 17.8397 8.24706 17.8397 8.61499V9.28452C17.8397 9.65245 17.5281 9.95103 17.1441 9.95103H15.7119",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2761 12.6894C12.5952 12.6894 14.4751 10.8882 14.4751 8.66624C14.4751 6.4443 12.5952 4.64307 10.2761 4.64307C7.9571 4.64307 6.07715 6.4443 6.07715 8.66624C6.07715 10.8882 7.9571 12.6894 10.2761 12.6894Z",
    stroke: "#6856DB",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9035 10.6901H10.8393C11.4028 10.6901 11.8592 10.2528 11.8592 9.71292C11.8592 9.17308 11.4028 8.73578 10.8393 8.73578H9.68098C9.11754 8.73578 8.66113 8.29848 8.66113 7.75864C8.66113 7.2188 9.11754 6.78149 9.68098 6.78149H11.6168",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4521 6.16919V6.78141",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2163 10.7563V11.2721",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0985 10.5V15.1625C22.0985 17.7502 19.9078 19.8492 17.2071 19.8492H7.47448C4.77378 19.8492 2.58301 17.7502 2.58301 15.1625V13.5038",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58301 10.1201V5.83755C2.58301 3.24993 4.77378 1.15088 7.47448 1.15088H17.2071C19.9078 1.15088 22.0985 3.24993 22.0985 5.83755V7.21882",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1697 8.98291L2.58328 10.4999L1 8.98291",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5156 11.7938L22.0989 10.2769L23.6853 11.7938",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePackageIcon);
export default __webpack_public_path__ + "static/media/ChangePackageIcon.2aed24b58fe4f218a0e2c695796c64f2.svg";
export { ForwardRef as ReactComponent };